import React, {
    useState,
    useEffect,
    useContext,
    useRef
} from "react";

import {
    JWT
} from "../constants/local-storage";

import {
    functions
} from "../constants/common-functions";

import {
    CSSTransition
} from "react-transition-group";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";

import "./dashboardphotonavigator.css";

import {
    store
} from "../context/store";


import {
    OMNISCAN_BLUE,
    OMNISCAN_BLUE_RGB,
    OMNISCAN_BLUE_SOFT
} from "../constants/colors";


export default function DashboardPhotoNavigator({
    refFacility,
    facilityId,
    setFacilityId,
    floorId,
    setFloorId,
    spaceId,
    setSpaceId,
    parentSpaceTypeId,
    setParentSpaceTypeId,
    spaceTypeId,
    setSpaceTypeId,
    parentOrganisationId,
    setParentOrganisationId,
    organisationId,
    setOrganisationId,
    setShowCoreDayOnly,
    showCoreDayOnly,
    showDesksMeetings,
    setShowDesksMeetings,
    floorZoneId,
    setFloorZoneId,
    resetFunction,
    utilisationDeskMeetingRemainder,
    setFilterBean
})
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // Constants
    //--------------------------------------------------------

    const SELECT_ALL_OPTION =
        "All";

    const OPEN_CLOSE_ICON_DEFAULT =
        "angle-left";


    //--------------------------------------------------------
    // Refs
    //--------------------------------------------------------

    const refParentSpaceType =
        useRef(null);

    const refSpaceType =
        useRef(null);

    const refParentOrganisation =
        useRef(null);

    const refOrganisation =
        useRef(null);

    const refFloor =
        useRef(null);

    const refSpace =
        useRef(null);

    const refFloorZone =
        useRef(null);


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [facilities, setFacilities] =
        useState([]);

    const [parentSpaceTypes, setParentSpaceTypes] =
        useState([]);

    const [spaceTypes, setSpaceTypes] =
        useState([]);

    const [parentOrganisations, setParentOrganisations] =
        useState([]);

    const [organisations, setOrganisations] =
        useState([]);

    const [floors, setFloors] =
        useState([]);

    const [floorZones, setFloorZones] =
        useState([]);

    const [spaces, setSpaces] =
        useState([]);

    const [facilityName, setFacilityName] =
        useState("");

    const [photoSource, setPhotoSource] =
        useState();

    const [photoDisplay, setPhotoDisplay] =
        useState("none");

    const [imageTextDisplay, setImageTextDisplay] =
        useState("none");

    const [thisDisplay, setThisDisplay] =
        useState(true);

    const [openCloseIcon, setOpenCloseIcon] =
        useState(
            OPEN_CLOSE_ICON_DEFAULT
        );

    const [displayParentLabel, setDisplayParentLabel] =
        useState("none");

    const [displayParentSelect, setDisplayParentSelect] =
        useState("flex");

    const [parentLabel, setParentLabel] =
        useState("none");

    const [displayBuildingView, setDisplayBuildingView] =
        useState("none");

    const [resetHovered, setResetHovered] =
        useState(false);

    const [floorplanHovered, setFloorplanHovered] =
        useState(false);

    const [collapseHovered, setCollapseHovered] =
        useState(false);


    //========================================================
    // Styles
    //========================================================

	//--------------------------------------------------------
	// Main content - floating smoked glass filter panel
	//--------------------------------------------------------

	const mainPanelContent =
	{
	    display: "flex",

	    width: "calc(100% - 32px)",

	    flexDirection: "column",

	    position: "relative",

	    alignSelf: "flex-start",

	    margin: "20px 20px 20px 20px",

	    padding: "0 18px 20px 18px",

	    height: "auto",

	    maxHeight: "calc(100vh - 40px)",

	    overflowY: "auto",

	    overflowX: "hidden",

	    boxSizing: "border-box",

	    background: "rgba(5, 12, 20, 0.38)",

	    backdropFilter: "blur(12px)",

	    WebkitBackdropFilter: "blur(12px)",

	    border: "1px solid rgba(255,255,255,0.10)",

	    borderRadius: "12px",

	    boxShadow:
	        "0 12px 35px rgba(0,0,0,0.20), " +
	        "inset 0 1px 0 rgba(255,255,255,0.05)",

	    scrollbarWidth: "thin",

	    scrollbarColor:
	        "rgba(141,200,240,0.30) transparent"
	};


    //--------------------------------------------------------
    // Reset button
    //--------------------------------------------------------

    const resetButtonStyle =
    {
        display:
            "flex",

        width:
            "fit-content",

        height:
            "32px",

        minHeight:
            "32px",

        padding:
            "0 15px",

        marginTop:
            "22px",

        alignItems:
            "center",

        justifyContent:
            "center",

        gap:
            "8px",

        boxSizing:
            "border-box",

		background:
		    resetHovered
		        ? `${OMNISCAN_BLUE_SOFT}2E`
		        : `${OMNISCAN_BLUE_SOFT}17`,

		border:
		    resetHovered
		        ? `1px solid ${OMNISCAN_BLUE_SOFT}7A`
		        : `1px solid ${OMNISCAN_BLUE_SOFT}47`,

        borderRadius:
            "16px",

        color:
            "#ffffff",

        fontSize:
            "12px",

        fontWeight:
            500,

        cursor:
            "pointer",

        transition:
            "background 0.18s ease, " +
            "border-color 0.18s ease"
    };


    const resetIconStyle =
    {
        width:
            "13px",

        height:
            "13px",

        color:
            OMNISCAN_BLUE_SOFT
    };


	//--------------------------------------------------------
	// Select
	//--------------------------------------------------------

	const DARK_SELECT =
	{
	    width:
	        "100%",

	    height:
	        "36px",

	    minHeight:
	        "36px",

	    boxSizing:
	        "border-box",

	    borderRadius:
	        "3px",

	    border:
	        "1px solid rgba(255,255,255,0.12)",

	    background:
	        "rgba(0,0,0,0.24)",

	    color:
	        "#ffffff",

	    fontSize:
	        "12px",

	    padding:
	        "0 12px",

	    outline:
	        "none",

	    cursor:
	        "pointer",

	    boxShadow:
	        "inset 0 1px 2px rgba(0,0,0,0.22)"
	};

    const DARK_OPTION =
    {
        backgroundColor:
            "#ffffff",

        color:
            "#1e2a38"
    };


    //--------------------------------------------------------
    // Section
    //--------------------------------------------------------

    const sectionStyle =
    {
        paddingTop:
            "15px",

        paddingBottom:
            "15px",

        borderBottom:
            "1px solid rgba(141,200,240,0.12)"
    };


    const firstSectionStyle =
    {
        ...sectionStyle,

        paddingTop:
            "22px"
    };


    //--------------------------------------------------------
    // Section row
    //--------------------------------------------------------

    const sectionRowStyle =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "100%",

        marginBottom:
            "15px"
    };


    //--------------------------------------------------------
    // Labels
    //--------------------------------------------------------

    const sectionTitleStyle =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        minHeight:
            "20px",

        marginBottom:
            "6px",

        color:
            "rgba(255,255,255,0.78)",

        fontSize:
            "12px",

        fontWeight:
            500
    };


    const parentValueStyle =
    {
        display:
            "flex",

        color:
            "#8dc8f0",

        fontSize:
            "12px",

        lineHeight:
            "17px",

        marginBottom:
            "6px"
    };


    //--------------------------------------------------------
    // Radio row
    //--------------------------------------------------------

    const radioRowStyle =
    {
        display:
            "flex",

        alignItems:
            "center",

        gap:
            "22px",

        marginTop:
            "7px"
    };


    const radioLabelStyle =
    {
        display:
            "flex",

        alignItems:
            "center",

        gap:
            "7px",

        cursor:
            "pointer",

        color:
            "rgba(255,255,255,0.84)",

        fontSize:
            "12px"
    };


    const radioStyle =
    {
        accentColor:
            OMNISCAN_BLUE_SOFT,

        cursor:
            "pointer"
    };


    //--------------------------------------------------------
    // Floorplan button
    //--------------------------------------------------------

    const floorplanButtonStyle =
    {
        display:
            "flex",

        width:
            "26px",

        height:
            "26px",

        alignItems:
            "center",

        justifyContent:
            "center",

        marginLeft:
            "8px",

        borderRadius:
            "50%",

		background:
		    floorplanHovered
		        ? "#1f6599"
		        : `${OMNISCAN_BLUE_SOFT}1A`,

		border:
		    `1px solid ${OMNISCAN_BLUE_SOFT}42`,

		color:
		    floorplanHovered
		        ? "#ffffff"
		        : OMNISCAN_BLUE_SOFT,

        cursor:
            "pointer",

        transition:
            "background 0.18s ease, color 0.18s ease"
    };


	//--------------------------------------------------------
	// Collapse control
	//--------------------------------------------------------

	const openCloseIconContainer =
	{
	    display:
	        "flex",

	    position:
	        "absolute",

	    right:
	        "-17px",

	    top:
	        "50%",

	    transform:
	        "translateY(-50%)",

	    width:
	        "34px",

	    height:
	        "34px",

	    minWidth:
	        "34px",

	    background:
	        `linear-gradient(
	            180deg,
	            ${OMNISCAN_BLUE} 0%,
	            #2695cc 100%
	        )`,

	    border:
	        "1px solid rgba(255,255,255,0.28)",

	    boxShadow:
	        "0 4px 12px rgba(0,0,0,0.22)",

	    borderRadius:
	        "50%",

	    alignItems:
	        "center",

	    justifyContent:
	        "center",

	    cursor:
	        "pointer",

	    zIndex:
	        2000,

	    transition:
	        "background 0.18s ease, box-shadow 0.18s ease"
	};

    const openCloseIconStyle =
    {
        display:
            "flex",

        color:
            "#ffffff",

        width:
            "14px",

        height:
            "14px",

        pointerEvents:
            "none"
    };


    //========================================================
    // Filter Bean
    //========================================================

    const getFilterBean =
        function()
        {

            const filterBeanTemp = {};


            filterBeanTemp.facilities =
                facilityId !== "-100"
                    ? [parseInt(facilityId)]
                    : [];

            filterBeanTemp.facilityExcludes =
                [];


            filterBeanTemp.floors =
                floorId !== "-100"
                    ? [parseInt(floorId)]
                    : [];

            filterBeanTemp.floorExcludes =
                [];


            filterBeanTemp.floorZones =
                floorZoneId !== "-100"
                    ? [parseInt(floorZoneId)]
                    : [];

            filterBeanTemp.floorZoneExcludes =
                [];


            filterBeanTemp.spaces =
                spaceId !== "-100"
                    ? [parseInt(spaceId)]
                    : [];

            filterBeanTemp.spaceExcludes =
                [];


            filterBeanTemp.spaceTypes =
                parentSpaceTypeId !== "-100"
                    ? [parseInt(parentSpaceTypeId)]
                    : [];

            filterBeanTemp.spaceTypeExcludes =
                [];


            filterBeanTemp.spaceTypeSubs =
                spaceTypeId !== "-100"
                    ? [parseInt(spaceTypeId)]
                    : [];

            filterBeanTemp.spaceTypeSubExcludes =
                [];


            filterBeanTemp.organisations =
                parentOrganisationId !== "-100"
                    ? [parseInt(parentOrganisationId)]
                    : [];

            filterBeanTemp.organisationExcludes =
                [];


            filterBeanTemp.organisationSubs =
                organisationId !== "-100"
                    ? [parseInt(organisationId)]
                    : [];

            filterBeanTemp.organisationSubExcludes =
                [];


            filterBeanTemp.classifications =
                [];

            filterBeanTemp.classificationExcludes =
                [];

            filterBeanTemp.classificationItems =
                [];

            filterBeanTemp.classificationItemExcludes =
                [];


            filterBeanTemp.showCoreDayOnly =
                parseInt(showCoreDayOnly);

            filterBeanTemp.showDesksMeetings =
                parseInt(showDesksMeetings);


            return filterBeanTemp;

        };


    //========================================================
    // Load data
    //========================================================

    useEffect(
        () =>
        {

            if(facilityId === "-100")
            {
                setDisplayBuildingView(
                    "none"
                );
            }
            else
            {
                setDisplayBuildingView(
                    "flex"
                );
            }


            loadFacility();

            loadParentSpaceTypes();


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetfloorsforfacility",
                functions.buildPostBodyFilterBeanQueryContext(
                    getFilterBean(),
                    queryContext
                ),
                setFloors
            );


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetfloorzonesforfloor",
                functions.buildPostBodyFilterBeanQueryContext(
                    getFilterBean(),
                    queryContext
                ),
                setFloorZones
            );


            if(
                floorId === "-100"
                &&
                facilityId != -100
            )
            {

                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstanardgetspacesforfacility",
                    functions.buildPostBodyFilterBeanQueryContext(
                        getFilterBean(),
                        queryContext
                    ),
                    setSpaces
                );

            }
            else
            {

                functions.postFilterBeanAjax(
                    "/resolutionsoftwareplatform/utilisationstandardgetspacesforfacilityandfloor",
                    functions.buildPostBodyFilterBeanQueryContext(
                        getFilterBean(),
                        queryContext
                    ),
                    setSpaces
                );

            }


            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetfacilities",
                functions.buildPostBodyFilterBeanQueryContext(
                    getFilterBean(),
                    queryContext
                ),
                setFacilities
            );


            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetspacetypes?parentId="
                + parentSpaceTypeId,
                setSpaceTypes,
                null
            );


            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetparentorganisations",
                setParentOrganisations,
                null
            );


            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationstandardgetorganisations?parentId="
                + parentOrganisationId,
                setOrganisations,
                null
            );

        },
        [
            facilityId,
            floorId,
            spaceId,
            spaceTypeId,
            parentSpaceTypeId,
            organisationId,
            parentOrganisationId,
            showCoreDayOnly,
            showDesksMeetings
        ]
    );


    //--------------------------------------------------------
    // Expose filter bean
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            if(setFilterBean)
            {
                setFilterBean(
                    getFilterBean()
                );
            }

        },
        [
            facilityId,
            floorId,
            floorZoneId,
            spaceId,
            parentSpaceTypeId,
            spaceTypeId,
            parentOrganisationId,
            organisationId,
            showCoreDayOnly,
            showDesksMeetings
        ]
    );


    //========================================================
    // Load helpers
    //========================================================

    const loadParentSpaceTypes =
        () =>
        {

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/utilisationgetparentspacetype?id="
                + parentSpaceTypeId,
                setParentSpaceTypes,
                handleParentLabel
            );

        };


    const handleParentLabel =
        (results) =>
        {

            if(results.length === 1)
            {

                setParentLabel(
                    results[0].code
                    + ": "
                    + results[0].description
                );

                setDisplayParentLabel(
                    "flex"
                );

                setDisplayParentSelect(
                    "none"
                );

            }
            else
            {

                setDisplayParentLabel(
                    "none"
                );

                setDisplayParentSelect(
                    "flex"
                );

            }

        };


    const loadFacility =
        () =>
        {

            setImageTextDisplay(
                "none"
            );

            setPhotoDisplay(
                "none"
            );


            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/getfacilitypopup?facilityId="
                + facilityId,
                null,
                buildTableRows
            );

        };


    const buildTableRows =
        (input) =>
        {

            setFacilityName(
                input.name
            );

            getClientInfo(
                input.code,
                input.photo
            );

        };


    const getClientInfo =
        (buildingCode, photo) =>
        {

            loadPhoto(
                globalState.state.client.resourceFolderUrl
                + "/buildingphotos/"
                + buildingCode
                + "/"
                + photo
            );

        };


    const loadPhoto =
        (imageUrl) =>
        {

            fetch(
                imageUrl,
                {
                    method:
                        "GET",

                    headers:
                    {
                        "Authorization":
                            localStorage.getItem(JWT)
                    }
                }
            )
            .then(
                result =>
                    result.blob()
            )
            .then(
                result =>
                {

                    if(result.size > 1000)
                    {

                        setPhotoSource(
                            URL.createObjectURL(result)
                        );

                        setPhotoDisplay(
                            "flex"
                        );

                        setImageTextDisplay(
                            "none"
                        );

                    }
                    else
                    {

                        setImageTextDisplay(
                            "flex"
                        );

                    }

                }
            );

        };


    //========================================================
    // Change handlers
    //========================================================

    const handleChangeFacility =
        (e) =>
        {

            setFacilityId(
                e.target.value
            );


            if(e.target.value === "-100")
            {

                setSpaceId(
                    "-100"
                );

                setFloorId(
                    "-100"
                );

            }

        };


    const handleChangeFloor =
        (e) =>
        {

            setFloorId(
                e.target.value
            );

            setSpaceId(
                "-100"
            );

        };


    const handleChangeFloorZone =
        (e) =>
        {

            setFloorZoneId(
                e.target.value
            );

            setSpaceId(
                "-100"
            );

        };


    //========================================================
    // Drawer
    //========================================================

    const handleOpenCloseIconClick =
        () =>
        {

            if(thisDisplay === true)
            {
                setOpenCloseIcon(
                    "filter"
                );
            }
            else
            {
                setOpenCloseIcon(
                    OPEN_CLOSE_ICON_DEFAULT
                );
            }


            setThisDisplay(
                !thisDisplay
            );

        };


    //========================================================
    // Reset
    //========================================================

    const handleReset =
        () =>
        {

            if(resetFunction)
            {

                if(refFacility.current)
                {
                    refFacility.current.value =
                        "-100";
                }


                if(refFloor.current)
                {
                    refFloor.current.value =
                        "-100";
                }


                if(refFloorZone.current)
                {
                    refFloorZone.current.value =
                        "-100";
                }


                if(refSpace.current)
                {
                    refSpace.current.value =
                        "-100";
                }


                if(refParentSpaceType.current)
                {
                    refParentSpaceType.current.value =
                        "-100";
                }


                if(refSpaceType.current)
                {
                    refSpaceType.current.value =
                        "-100";
                }


                if(refParentOrganisation.current)
                {
                    refParentOrganisation.current.value =
                        "-100";
                }


                if(refOrganisation.current)
                {
                    refOrganisation.current.value =
                        "-100";
                }


                resetFunction();

            }

        };


    //========================================================
    // Floorplan
    //========================================================

    const handleOpenFloorplan =
        () =>
        {

            const selectedFloorId =
                refFloor.current
                    ? refFloor.current.value
                    : "-100";


            if(
                selectedFloorId === "-100"
                ||
                !selectedFloorId
            )
            {

                alert(
                    "Please select a floor"
                );

                return;

            }


            const surveyId =
                -100;


            window.location =
                "/floorplan/utilisation/"
                + selectedFloorId
                + "?surveyId="
                + surveyId;

        };


    //========================================================
    // Render
    //========================================================

    return (

        <CSSTransition

            in={
                thisDisplay
            }

            classNames="dashboardphotonavigator"

            timeout={
                1000
            }

            appear={
                false
            }

        >

            <div
                className="dashboardphotonavigator"
            >

                <div
                    style={
                        mainPanelContent
                    }
                >


                    {/* ========================================
                        RESET
                    ========================================= */}

                    <div

                        style={
                            resetButtonStyle
                        }

                        onClick={
                            handleReset
                        }

                        onMouseEnter={
                            () =>
                                setResetHovered(true)
                        }

                        onMouseLeave={
                            () =>
                                setResetHovered(false)
                        }

                    >

                        <FontAwesomeIcon
                            icon="sync"
                            style={resetIconStyle}
                        />

                        Reset

                    </div>


                    {/* ========================================
                        CORE DAY
                    ========================================= */}

                    <div
                        style={
                            firstSectionStyle
                        }
                    >

                        <div
                            style={
                                sectionTitleStyle
                            }
                        >

                            Core Day Only

                        </div>


                        <div
                            style={
                                radioRowStyle
                            }
                        >

                            <label
                                style={
                                    radioLabelStyle
                                }
                            >

                                <input
                                    type="radio"
                                    name="coreday"
                                    value="0"
                                    checked={
                                        String(showCoreDayOnly) === "0"
                                    }
                                    onChange={
                                        (e) =>
                                            setShowCoreDayOnly(
                                                e.target.value
                                            )
                                    }
                                    style={
                                        radioStyle
                                    }
                                />

                                No

                            </label>


                            <label
                                style={
                                    radioLabelStyle
                                }
                            >

                                <input
                                    type="radio"
                                    name="coreday"
                                    value="1"
                                    checked={
                                        String(showCoreDayOnly) === "1"
                                    }
                                    onChange={
                                        (e) =>
                                            setShowCoreDayOnly(
                                                e.target.value
                                            )
                                    }
                                    style={
                                        radioStyle
                                    }
                                />

                                Yes

                            </label>

                        </div>

                    </div>


                    {/* ========================================
                        WORK SETTING TYPE
                    ========================================= */}

                    <div
                        style={
                            sectionStyle
                        }
                    >

                        <div
                            style={
                                sectionRowStyle
                            }
                        >

                            <div
                                style={
                                    sectionTitleStyle
                                }
                            >

                                Work Setting Type

                            </div>


                            {
                                displayParentLabel === "flex"
                                &&

                                <div
                                    style={
                                        parentValueStyle
                                    }
                                >

                                    {parentLabel}

                                </div>
                            }


                            {
                                displayParentSelect === "flex"
                                &&

                                <select

                                    style={
                                        DARK_SELECT
                                    }

                                    ref={
                                        refParentSpaceType
                                    }

                                    value={
                                        parentSpaceTypeId
                                    }

                                    onChange={
                                        (e) =>
                                            setParentSpaceTypeId(
                                                e.target.value
                                            )
                                    }

                                >

                                    <option
                                        style={DARK_OPTION}
                                        value="-100"
                                    >

                                        {SELECT_ALL_OPTION}

                                    </option>


                                    {
                                        parentSpaceTypes.map(
                                            (item) => (

                                                <option
                                                    style={DARK_OPTION}
                                                    key={item.id}
                                                    value={item.id}
                                                >

                                                    {item.name}

                                                </option>

                                            )
                                        )
                                    }

                                </select>
                            }

                        </div>


                        {/* ====================================
                            WORK SETTING SUB TYPE
                        ===================================== */}

                        <div
                            style={
                                sectionRowStyle
                            }
                        >

                            <div
                                style={
                                    sectionTitleStyle
                                }
                            >

                                Work Setting Sub Type

                            </div>


                            <select

                                style={
                                    DARK_SELECT
                                }

                                ref={
                                    refSpaceType
                                }

                                value={
                                    spaceTypeId
                                }

                                onChange={
                                    (e) =>
                                        setSpaceTypeId(
                                            e.target.value
                                        )
                                }

                            >

                                <option
                                    style={DARK_OPTION}
                                    value="-100"
                                >

                                    {SELECT_ALL_OPTION}

                                </option>


                                {
                                    spaceTypes.map(
                                        (item) => (

                                            <option
                                                style={DARK_OPTION}
                                                key={item.id}
                                                value={item.id}
                                            >

                                                {item.name}

                                            </option>

                                        )
                                    )
                                }

                            </select>

                        </div>


                        {/* ====================================
                            DIRECTORATE
                        ===================================== */}

                        <div
                            style={
                                sectionRowStyle
                            }
                        >

                            <div
                                style={
                                    sectionTitleStyle
                                }
                            >

                                Directorate

                            </div>


                            <select

                                style={
                                    DARK_SELECT
                                }

                                ref={
                                    refParentOrganisation
                                }

                                value={
                                    parentOrganisationId
                                }

                                onChange={
                                    (e) =>
                                        setParentOrganisationId(
                                            e.target.value
                                        )
                                }

                            >

                                <option
                                    style={DARK_OPTION}
                                    value="-100"
                                >

                                    {SELECT_ALL_OPTION}

                                </option>


                                {
                                    parentOrganisations.map(
                                        (item) => (

                                            <option
                                                style={DARK_OPTION}
                                                key={item.id}
                                                value={item.id}
                                            >

                                                {item.name}

                                            </option>

                                        )
                                    )
                                }

                            </select>

                        </div>


                        {/* ====================================
                            TEAM
                        ===================================== */}

                        <div
                            style={
                                sectionRowStyle
                            }
                        >

                            <div
                                style={
                                    sectionTitleStyle
                                }
                            >

                                Team

                            </div>


                            <select

                                style={
                                    DARK_SELECT
                                }

                                ref={
                                    refOrganisation
                                }

                                value={
                                    organisationId
                                }

                                onChange={
                                    (e) =>
                                        setOrganisationId(
                                            e.target.value
                                        )
                                }

                            >

                                <option
                                    style={DARK_OPTION}
                                    value="-100"
                                >

                                    {SELECT_ALL_OPTION}

                                </option>


                                {
                                    organisations.map(
                                        (item) => (

                                            <option
                                                style={DARK_OPTION}
                                                key={item.id}
                                                value={item.id}
                                            >

                                                {item.name}

                                            </option>

                                        )
                                    )
                                }

                            </select>

                        </div>


                        {/* ====================================
                            BUILDING
                        ===================================== */}

                        <div
                            style={
                                sectionRowStyle
                            }
                        >

                            <div
                                style={
                                    sectionTitleStyle
                                }
                            >

                                Building

                            </div>


                            <select

                                style={
                                    DARK_SELECT
                                }

                                ref={
                                    refFacility
                                }

                                value={
                                    facilityId
                                }

                                onChange={
                                    handleChangeFacility
                                }

                            >

                                <option
                                    style={DARK_OPTION}
                                    value="-100"
                                >

                                    {SELECT_ALL_OPTION}

                                </option>


                                {
                                    Array.isArray(facilities)
                                    &&
                                    facilities.map(
                                        (item) => (

                                            <option
                                                style={DARK_OPTION}
                                                key={item.id}
                                                value={item.id}
                                            >

                                                {item.name}

                                            </option>

                                        )
                                    )
                                }

                            </select>

                        </div>


                        {/* ====================================
                            BUILDING-SPECIFIC FILTERS
                        ===================================== */}

                        {
                            displayBuildingView === "flex"
                            &&

                            <>

                                {/* ============================
                                    FLOOR
                                ============================= */}

                                <div
                                    style={
                                        sectionRowStyle
                                    }
                                >

                                    <div
                                        style={
                                            sectionTitleStyle
                                        }
                                    >

                                        <span>
                                            Floor
                                        </span>


                                        <div

                                            style={
                                                floorplanButtonStyle
                                            }

                                            title="Open floorplan"

                                            onClick={
                                                handleOpenFloorplan
                                            }

                                            onMouseEnter={
                                                () =>
                                                    setFloorplanHovered(
                                                        true
                                                    )
                                            }

                                            onMouseLeave={
                                                () =>
                                                    setFloorplanHovered(
                                                        false
                                                    )
                                            }

                                        >

                                            <FontAwesomeIcon
                                                icon="map"
                                                style={{
                                                    width: "13px",
                                                    height: "13px"
                                                }}
                                            />

                                        </div>

                                    </div>


                                    <select

                                        style={
                                            DARK_SELECT
                                        }

                                        ref={
                                            refFloor
                                        }

                                        value={
                                            floorId
                                        }

                                        onChange={
                                            handleChangeFloor
                                        }

                                    >

                                        <option
                                            style={DARK_OPTION}
                                            value="-100"
                                        >

                                            Select

                                        </option>


                                        {
                                            Array.isArray(floors)
                                            &&
                                            floors.map(
                                                (item) => (

                                                    <option
                                                        style={DARK_OPTION}
                                                        key={item.id}
                                                        value={item.id}
                                                    >

                                                        {item.name}

                                                    </option>

                                                )
                                            )
                                        }

                                    </select>

                                </div>


                                {/* ============================
                                    FLOOR ZONE
                                ============================= */}

                                <div
                                    style={
                                        sectionRowStyle
                                    }
                                >

                                    <div
                                        style={
                                            sectionTitleStyle
                                        }
                                    >

                                        Floor Zone

                                    </div>


                                    <select

                                        style={
                                            DARK_SELECT
                                        }

                                        ref={
                                            refFloorZone
                                        }

                                        value={
                                            floorZoneId
                                        }

                                        onChange={
                                            handleChangeFloorZone
                                        }

                                    >

                                        <option
                                            style={DARK_OPTION}
                                            value="-100"
                                        >

                                            Select

                                        </option>


                                        {
                                            Array.isArray(floorZones)
                                            &&
                                            floorZones.map(
                                                (item) => (

                                                    <option
                                                        style={DARK_OPTION}
                                                        key={item.id}
                                                        value={item.id}
                                                    >

                                                        {item.name}

                                                    </option>

                                                )
                                            )
                                        }

                                    </select>

                                </div>


                                {/* ============================
                                    WORK SETTING
                                ============================= */}

                                <div
                                    style={{
                                        ...sectionRowStyle,
                                        marginBottom: "0px"
                                    }}
                                >

                                    <div
                                        style={
                                            sectionTitleStyle
                                        }
                                    >

                                        Work Setting

                                    </div>


                                    <select

                                        style={
                                            DARK_SELECT
                                        }

                                        ref={
                                            refSpace
                                        }

                                        value={
                                            spaceId
                                        }

                                        onChange={
                                            (e) =>
                                                setSpaceId(
                                                    e.target.value
                                                )
                                        }

                                    >

                                        <option
                                            style={DARK_OPTION}
                                            value="-100"
                                        >

                                            Select

                                        </option>


                                        {
                                            Array.isArray(spaces)
                                            &&
                                            spaces.map(
                                                (item) => (

                                                    <option
                                                        style={DARK_OPTION}
                                                        key={item.id}
                                                        value={item.id}
                                                    >

                                                        {item.code}

                                                    </option>

                                                )
                                            )
                                        }

                                    </select>

                                </div>

                            </>

                        }

                    </div>

                </div>


                {/* ============================================
                    OPEN / CLOSE
                ============================================= */}

                <div

                    style={
                        openCloseIconContainer
                    }

                    className={
                        `drawer-close ${
                            thisDisplay
                                ? "rotated"
                                : ""
                        }`
                    }

                    onClick={
                        handleOpenCloseIconClick
                    }

                    onMouseEnter={
                        () =>
                            setCollapseHovered(true)
                    }

                    onMouseLeave={
                        () =>
                            setCollapseHovered(false)
                    }

                >

                    <FontAwesomeIcon
                        icon={
                            openCloseIcon
                        }

                        style={
                            openCloseIconStyle
                        }
                    />

                </div>

            </div>

        </CSSTransition>

    );

}